<template>
  <modal @close="closeModal" class="modal-image" :displayCross="true">
    <img :src="imgPath">
  </modal>

</template>

<script>
  import Modal from "../Granular/Modal";
  export default {
    name: "Modal-image",
    components: {Modal},
    props: ['image'],
    methods: {
      closeModal() {
        this.$emit('close');
      }
    },
    computed: {
      imgPath() {
        if (this.image) {
          if (this.image.startsWith('http')|| this.image.startsWith('//')) {
            return this.image;
          } else {
            return process.env.VUE_APP_URL_UPLOADS + this.image;
          }
        } else {
          return '';
        }
      }
    },
  }
</script>

<style lang="scss">
  .modal-image {
    img {
      max-height: none;
    }

    .btn-close {
      padding-bottom: rem(15px);
      margin-right: rem(-20px);
    }
  }
</style>